var map = {
	"./algas-marinhas.jpg": 8900,
	"./aquarela.jpg": 22023,
	"./bg-algas-marinhas.png": 71734,
	"./bg-aquarela.png": 91336,
	"./bg-classico.png": 50478,
	"./bg-conchas-oceano.png": 32902,
	"./bg-floral-clean.png": 77298,
	"./bg-floral-ellegance.png": 5267,
	"./bg-floral-maritimo.png": 65279,
	"./bg-floral-night.png": 17834,
	"./bg-floral-rustico.png": 25120,
	"./bg-florani.png": 10047,
	"./bg-moderno.png": 53187,
	"./bg-pintura.png": 73801,
	"./bg-por-do-sol.png": 32968,
	"./bg-romantico.png": 56346,
	"./bg-rustico.png": 3711,
	"./classico.jpg": 43676,
	"./conchas-no-oceano.jpg": 8405,
	"./floral-clean.png": 55473,
	"./floral-ellegance.png": 51513,
	"./floral-maritimo.png": 53576,
	"./floral-night.png": 3670,
	"./floral-rustico.png": 78696,
	"./florani.png": 43761,
	"./moderno.jpg": 40217,
	"./pintura.jpg": 90173,
	"./por-do-sol.jpg": 91264,
	"./romantico.jpg": 73293,
	"./rustico.jpg": 85715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91330;